import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptedBaseQueryWithReauth } from "../../utilities/encryptedBaseQuery";

export const courseAccessApi = createApi({
    reducerPath: "courseAccessApi",
    baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),

    endpoints: (builder) => ({

        sinkCourse: builder.mutation({
            query: ({ endpoint, data }) => ({
                url: endpoint,
                method: "PATCH",
                body: data,
            }),
        }),
        courseAccess: builder.mutation({
            query: ({ endpoint, payload }) => ({
                url: endpoint,
                method: "PATCH",
                body: payload,
            }),
        }),
        removeAccess: builder.mutation({
            query: ({ endpoint, payload }) => ({
                url: endpoint,
                method: "DELETE",
                body: payload,
            }),
        }),
        liveAndCompleteClass: builder.mutation({
            query: ({ endpoint, payload }) => ({
                url: endpoint,
                method: "PATCH",
                body: payload,
            }),
        }),
        saveRecording: builder.query({
            query: (endpoint) => `${endpoint}`,
        }),
        changeClassStatus: builder.mutation({
            query: ({ endpoint, payload }) => ({
                url: endpoint,
                method: "PATCH",
                body: payload,
            }),
        }),
    }),
});

export const {
    useSinkCourseMutation,
    // useSaveRecordingMutation,
    useLazySaveRecordingQuery,
    useLiveAndCompleteClassMutation,
    useCourseAccessMutation,
    useRemoveAccessMutation,
    useChangeClassStatusMutation,
} = courseAccessApi;

